// ─────────────────────────────────────────────
// DOCUMENT CONFIG (NO CHANGE)
// ─────────────────────────────────────────────

export const DRIVER_DOC_FIELDS = [
  { key: "DRIVER_LICENSE_FRONT", label: "Driver DL Front" },
  { key: "DRIVER_LICENSE_BACK", label: "Driver DL Back" },
  { key: "DRIVER_AADHAAR", label: "Driver Aadhaar Card" },
];

export const DOCUMENT_FIELDS = [
  { key: "rc", label: "RC Image" },
  { key: "permit_5_year", label: "NP (5 Year)" },
  { key: "np_1_year",     label: "NP (1 Year)"      },
  { key: "fitness", label: "Fitness"           },
  { key: "pucc",    label: "PUCC Image"        },
  { key: "policy",  label: "Policy Document"    },
  { key: "VEHICLE_TAX", label: "Vehicle Tax Document" },
];

export const HELPER_DOC_FIELDS = [
  { key: "HELPER_LICENSE_FRONT", label: "Co-Pilot DL Front" },
  { key: "HELPER_LICENSE_BACK", label: "Co-Pilot DL Back" },
];

export const FIR_DOC_FIELD = { key: "fir", label: "FIR Image" };
export const LR_DOC_FIELD = { key: "lr", label: "LR Image" };

export const ACCIDENT_IMAGE_FIELDS = [
  { key: "ACCIDENT_FRONT_LEFT", label: "Front Left" },
  { key: "ACCIDENT_FRONT_RIGHT", label: "Front Right" },
  { key: "ACCIDENT_RIGHT_SIDE", label: "Right Side" },
  { key: "ACCIDENT_LEFT_SIDE", label: "Left Side" },
  { key: "ACCIDENT_BACK_LEFT", label: "Back Left" },
  { key: "ACCIDENT_BACK_RIGHT", label: "Back Right" },
];

// ─────────────────────────────────────────────
// EMPTY FORM
// ─────────────────────────────────────────────

export const EMPTY_FORM = {
  regNo: "",
  driverName: "",
  helper: "No",
  helperName: "",
  thirdParty: "No",
  firYes: "No",
  loaded: "No",
  accidentDate: "",
  accidentCause: "",
  repName: "",
  repEmail: "",
  repPhone: "",
};

// ─────────────────────────────────────────────
// STATUS FLOW (KEEPING YOUR BACKEND SAFE)
// ─────────────────────────────────────────────

export const STATUS_FLOW = [
  "CASE_REGISTERED",
  "DOCUMENTS_SUBMITTED",
  "SPOT_SURVEY_ASSIGNED",
  "SPOT_SURVEY_COMPLETED",
  "WORKSHOP_ASSIGNED",
  "DISMANTLING_COMPLETED",
  "SECOND_SURVEY_COMPLETED",
  "FINAL_SURVEY_COMPLETED",
  "ROAD_TRIAL_COMPLETED",
  "PAYMENT_COMPLETED",
  "CASE_CLOSED",
];

export const STATUS_TO_STEP = {
  DOCUMENTS_SUBMITTED: "docs",
  SPOT_SURVEY_ASSIGNED: "surveyor",
  SPOT_SURVEY_COMPLETED: "surveyor",
  WORKSHOP_ASSIGNED: "workshop",
  DISMANTLING_COMPLETED: "dismantle",
  SECOND_SURVEY_COMPLETED: "secondsurvey",
  FINAL_SURVEY_COMPLETED: "workshopsurvey",
  ROAD_TRIAL_COMPLETED: "roadtrial",
  PAYMENT_COMPLETED: "payment",
  CASE_CLOSED: "closed",
};

// ─────────────────────────────────────────────
// 🔥 NEW STEPS (YOUR UPDATED FLOW)
// ─────────────────────────────────────────────

export const STEPS = [
  { id: "docs", label: "Document Update", emoji: "📄", color: "#6366f1" },

  { id: "surveyor", label: "Spot Surveyor", emoji: "🔍", color: "#8b5cf6" },

  { id: "services", label: "Required Services", emoji: "🚛", color: "#0ea5e9" },

  { id: "workshop", label: "Workshop", emoji: "🔧", color: "#f59e0b" },

  { id: "claimform", label: "Claim Form", emoji: "📑", color: "#ec4899" },

  { id: "workshopsurvey", label: "Workshop Survey", emoji: "📊", color: "#22c55e" },

  { id: "dismantle", label: "Dismantle", emoji: "✂️", color: "#ef4444" },

  { id: "secondsurvey", label: "Second Survey", emoji: "🔁", color: "#8b5cf6" },

  { id: "reinspection", label: "Reinspection", emoji: "🔍", color: "#10b981" },

  { id: "paperwork", label: "Other Paperwork", emoji: "📂", color: "#6366f1" },

  { id: "roadtrial", label: "Road Trial", emoji: "🛣️", color: "#f59e0b" },

  { id: "payment", label: "D/O & Payment", emoji: "💳", color: "#d97706", special: "payment" },

  { id: "claim", label: "Pending Claim", emoji: "⏳", color: "#f97316" },

  { id: "closed", label: "Case Closed", emoji: "✅", color: "#22c55e" },
];

// ─────────────────────────────────────────────
// DEFAULT STEP BUILDER
// ─────────────────────────────────────────────

export const makeDefaultSteps = () =>
  STEPS.map((step) => ({
    ...step,
    completed: false,
    completedAt: null,
    updatedAt: null,
    doneBy: null,
    notes: null,
  }));

// ─────────────────────────────────────────────
// 🔥 MERGE API STEPS (MAIN LOGIC)
// ─────────────────────────────────────────────

export const mergeApiSteps = (apiSteps, currentStatus, caseData = {},  docs = [], surveyors = [], workshop = null, dismantle = null) => {
  if (!Array.isArray(apiSteps)) return makeDefaultSteps();

  const currentIndex = STATUS_FLOW.indexOf(currentStatus);

  const spotSurvey     = surveyors.find(s => s.surveyType === "SPOT_SURVEY");
  const workshopSurvey = surveyors.find(s => s.surveyType === "WORKSHOP_SURVEY");

  return STEPS.map((step) => {
    const fromApi = apiSteps.find((s) => s.id === step.id) || {};

    let completed = fromApi.completed ?? false;

    if (currentIndex !== -1) {
      const doneStatuses = STATUS_FLOW.slice(0, currentIndex + 1);
      const doneSteps = doneStatuses.map((s) => STATUS_TO_STEP[s]);

      if (doneSteps.includes(step.id)) {
        completed = true;
      }
    }

     if (step.id === "services" && caseData.onSpotService) {
      completed = true;
    }

     if (step.id === "surveyor" && spotSurvey) {
      completed = true;
    }

    if (step.id === "workshopsurvey" && workshopSurvey) {
      completed = true;
    }

    if (step.id === "workshop" && workshop?.workshopAssignedDate)       completed = true;

    if (step.id === "dismantle" && dismantle?.dismantlingCompletedDate)  completed = true;

    if (step.id === "docs" && Array.isArray(docs) && docs.length > 0)          completed = true;

    if (step.id === "claimform" && caseData?.claimFormSignedDoc) completed = true;

    if (step.id === "payment" && workshop?.estimateApprovedDate)       completed = true;

    return {
      ...step,
      completed,

      completedAt: fromApi.completedAt || null,
      updatedAt: fromApi.updatedAt || null,
      doneBy: fromApi.doneBy || null,
      notes: fromApi.notes || null,

      // 🔥 NEW DATA SUPPORT

      name: fromApi.name,
      email: fromApi.email,
      phone: fromApi.phone,

      serviceType: fromApi.serviceType || caseData.onSpotService || null,

      place: fromApi.place,

      stage: fromApi.stage,

      status: fromApi.status,

      // PAYMENT
      ...(step.special === "payment" && {
        amount: fromApi.amount,
        paymentStatus: fromApi.paymentStatus,
      }),
    };
  });
};